import React from "react";
import "./minigames.css";

export default function MiniGames() {
  const games = [
    {
      name: "BNTrivia",
      desc: "Real-time multiplayer. Test your ECE knowledge in Trivia or Ranking modes.",
      link: "https://bntrivia.vercel.app/",
      icon: "🎮",
      preview: "pics/previews/bntrivia.png" 
    },
    {
      name: "BEE & TEA",
      desc: "Fly your way to the top! Collect tea and hit the score goals for a chance to win exciting prizes.",
      link: "https://bee-and-tea.vercel.app/", 
      icon: "🐝",
      preview: "pics/previews/beetea.png"
    }
  ];

  return (
    <div className="minigames-page-wrapper">
      <div className="games-container">
        <h2 className="games-title">BNT MINI GAMES</h2>
        <p className="games-subtitle">Choose your mini game and have some fun!</p>
        <hr className="qual-divider" />

        <div className="games-grid">
          {games.map((game, index) => (
            <a 
              key={index}
              href={game.link} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="game-card"
            >
              {/* SCREENSHOT PREVIEW LAYER */}
              <div className="card-preview">
                <img src={game.preview} alt={`${game.name} preview`} />
                <div className="preview-overlay"></div>
              </div>

              <div className="game-icon">{game.icon}</div>
              <div className="game-info">
                <h3 className="game-name">{game.name}</h3>
                <p className="game-desc">{game.desc}</p>
              </div>
              <div className="game-arrow">→</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}